module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_AF.4ee15ce4.txt";